export default __webpack_public_path__ + "static/media/doctor-kid.fc80de8a.svg";